import { InferType, object, string } from 'yup';

export const signInSchema = object({
  email: string().email().required(),
  password: string().required(),
});

export type SignInFormPayload = InferType<typeof signInSchema>;
